import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button } from "@zapier/design-system";
export const ExtendTrialButton = ({ onClick, text = "Start trial" }) => (_jsx(Button, { color: "secondary", onClick: onClick, children: text }));

// @zapier/upsells@8.0.1 (466b4077f)
